export const TARGET_OPTIONS = [
  { value: 'FIRST_PARTY', label: 'First party' },
  { value: 'THIRD_PARTY', label: 'Third party' }
]

export const TARGET_OPTIONS_LABELS = {
  'FIRST_PARTY': 'First party',
  'THIRD_PARTY': 'Third party'
}

export const TARGET_TYPES = {
  'FIRST_PARTY': 'FIRST_PARTY',
  'THIRD_PARTY': 'THIRD_PARTY'
}
